/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function MagnetStraight(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M200,40H160a16.01833,16.01833,0,0,0-16,16v88a16,16,0,0,1-32,0V56A16.01833,16.01833,0,0,0,96,40H56A16.01833,16.01833,0,0,0,40,56v88a87.99955,87.99955,0,0,0,87.99512,88c.22265,0,.44726-.001.6709-.00195,48.15625-.35743,87.334-40.28321,87.334-89.002V56A16.01833,16.01833,0,0,0,200,40Zm0,16V96H160V56ZM96,56V96H56V56Z" />
    </Svg>
  );
}

export default MagnetStraight;
